import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { role: "banner" }

import {useHeaderLockPositionStore} from "@/stores/headerLockPosition";
import Header from "@/layouts/common/Header.vue"
import {computed, onBeforeMount, ref, Ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthenticableHeader',
  setup(__props) {

const headerLockPosition = useHeaderLockPositionStore();
const locked = headerLockPosition.lockedData as Ref<boolean>;

// const userref = ref<IUser>();
// const firstname: Ref<string | undefined> = computed(() => userref.value?.firstname);
// const lastname: Ref<string | undefined> = computed(() => userref.value?.lastname);
//
// onBeforeMount(() => {
//   userStore.getUser().then((userEl: IUser | undefined) => userref.value = userEl);
// })

function setClientHeight(height: number) {
  headerLockPosition.setHeight(height);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      onClientHeight: setClientHeight,
      locked: _unref(locked)
    }, null, 8, ["locked"])
  ]))
}
}

})